var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeTextMedicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.5H23M21.087 10H13.4348M16.3044 13.375H13.4348M2.91304 1H21.087C22.1435 1 23 2.00736 23 3.25V16.75C23 17.9926 22.1435 19 21.087 19H2.91304C1.8565 19 1 17.9926 1 16.75V3.25C1 2.00736 1.8565 1 2.91304 1ZM9.60876 11.4062C9.60876 11.3317 9.58357 11.2601 9.53872 11.2074C9.49387 11.1546 9.43305 11.125 9.36963 11.125H7.69572V9.15625C7.69572 9.08166 7.67052 9.01012 7.62568 8.95738C7.58083 8.90463 7.52001 8.875 7.45659 8.875H6.0218C5.95838 8.875 5.89756 8.90463 5.85271 8.95738C5.80787 9.01012 5.78267 9.08166 5.78267 9.15625V11.125H4.10876C4.04534 11.125 3.98451 11.1546 3.93967 11.2074C3.89482 11.2601 3.86963 11.3317 3.86963 11.4062V13.0938C3.86963 13.1683 3.89482 13.2399 3.93967 13.2926C3.98451 13.3454 4.04534 13.375 4.10876 13.375H5.78267V15.3438C5.78267 15.4183 5.80787 15.4899 5.85271 15.5426C5.89756 15.5954 5.95838 15.625 6.0218 15.625H7.45659C7.52001 15.625 7.58083 15.5954 7.62568 15.5426C7.67052 15.4899 7.69572 15.4183 7.69572 15.3438V13.375H9.36963C9.43305 13.375 9.49387 13.3454 9.53872 13.2926C9.58357 13.2399 9.60876 13.1683 9.60876 13.0938V11.4062Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeTextMedicationIcon);
export default __webpack_public_path__ + "static/media/FreeTextMedicationIcon.e1ec94d86825ee62e0a4c106c96023a7.svg";
export { ForwardRef as ReactComponent };